export default __webpack_public_path__ + "5eab7da071a2ce162482914b32c46140.svg";